"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestScript_Capability = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
exports.RTTI_TestScript_Capability = t.recursion('ITestScript_Capability', function () {
    return t.intersection([
        t.type({
            capabilities: RTTI_canonical_1.RTTI_canonical
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            required: t.boolean,
            _required: RTTI_Element_1.RTTI_Element,
            validated: t.boolean,
            _validated: RTTI_Element_1.RTTI_Element,
            description: t.string,
            _description: RTTI_Element_1.RTTI_Element,
            origin: t.array(RTTI_integer_1.RTTI_integer),
            _origin: t.array(RTTI_Element_1.RTTI_Element),
            destination: RTTI_integer_1.RTTI_integer,
            _destination: RTTI_Element_1.RTTI_Element,
            link: t.array(RTTI_uri_1.RTTI_uri),
            _link: t.array(RTTI_Element_1.RTTI_Element)
        })
    ]);
});
//# sourceMappingURL=RTTI_TestScript_Capability.js.map